'use strict';

var array = require('./array');

module.exports = function(options, validKeys) {
  for (var key in options) {
    if (array.indexOf(validKeys, key) < 0)
      throw new Error('Unrecognized option: ' + key);
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/util/validate_options.js
 ** module id = 13
 ** module chunks = 0
 **/